import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { catchError, take } from 'rxjs/operators';

import { RxComposite } from '@nrwl/rx-forms';
import { UserFile } from '@nrwl/rx-models';
import { UserFileService } from '@nrwl/rx-service-userfile';
import { WebviewService } from '@nrwl/rx-webview-service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RxButtonModule } from '@nrwl/rx-button';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxSignatureModule } from '@nrwl/rx-signature';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RxFormBuilderModule } from '../../../rx-form-builder.module';
import { RxFormPresenterComponent } from '../../rx-form-presenter.component';

@Component({
  selector: 'attachment-dialog',
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    RxIconModule,
    RxButtonModule,
    RxSignatureModule,
  ],
})
export class AttachmentDialogComponent extends RxComposite implements OnInit, AfterViewInit {
  public images = [];
  public busy = false;

  constructor(
    private userFileService: UserFileService,
    private _cd: ChangeDetectorRef,
    public webviewService: WebviewService,
  ) {
    super();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    // if(this.payload && this.payload.signature) {
    //     this.signature.fromDataURL(this.payload.signature);
    // }
  }

  onBrowseClientLibraryClicked($event) {}

  onAttachClicked($event) {}

  onCancelClicked($event) {
    this.dialog.close();
  }

  public onUploadedFiles(file: any) {
    if (!file) return;
    this.setupReader(file[0]);
  }

  private setupReader(file: File) {
    const reader = new FileReader();
    this.busy = true;
    reader.onload = (e: any) => {
      this.userFileService
        .postBase64(e.target.result)
        .pipe(
          take(1),
          catchError((error) => {
            return null;
          }),
        )
        .subscribe((result: UserFile | any) => {
          console.log('postBase64 to /v3/user-file/ result:', result);
          if (result) {
            this.images.push({
              id: result.id,
              // file: result.file,
              // thumb: result.thumb,
              // thumb_high_res: result.thumb_high_res
            });
            this.payload.data = this.images;
            this.dialog.submitClicked(this.images);
          } else {
          }
          this._cd.detectChanges();
        });
    };

    reader.readAsDataURL(file);
  }
}
